/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Data_Type_StringInputs */

const en_enum_setting_data_type_string = /** @type {(inputs: Enum_Setting_Data_Type_StringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Type String`)
};

const de_enum_setting_data_type_string = /** @type {(inputs: Enum_Setting_Data_Type_StringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Typ String`)
};

/**
* | output |
* | --- |
* | "Data Type String" |
*
* @param {Enum_Setting_Data_Type_StringInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_data_type_string = /** @type {((inputs?: Enum_Setting_Data_Type_StringInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Data_Type_StringInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_data_type_string(inputs)
	return de_enum_setting_data_type_string(inputs)
});